// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const ACarotenoids  = {
  productCode: " SBOVZ-A + PC",
  productName: "Natural Phyto Carotenoids ",
  ingredients: "Dacus carota, Solanum lycopersicum, Moringa oleifera ",
  overview:"A-Carotenoids is a blend of organic carrot, tomato, moringa leaf extracts standardized for 8% natural phyto carotenoids. The product is standardized as a balanced mix of carotenoids in the form of both Provitamin A and non-provitamin A carotenoids.",
  assay:"Mixed Carotenoids  8 % ",
  coNutrients:"Three complementary sources offer polyacetylenes, phenolic acids, and flavonoids provide a synergistic response that greatly contributes to potential antioxidant benefits and microenvironment synergy. Flavonoids and polyphenols retained during extraction increases the antioxidant profile.",
  studies:"Comprehensive Stability studies, Cell-assays for cognitive health, ongoing studies to comprehend how Phyto Carotenoids supplementation enhances several biomarkers of immune function.",
  benefits:"Helps prevent cancer, fights toxins, alleviates neuropathic pain, improves heart health and relieves oxidative stress in bones. Helps in preventing age-related macular degeneration (AMD) and reduce incidence of cataract. It is also known to prevent the formation of atherosclerosis (arterial wall thickening). Beta-cryptoxanthin could help in preventing arthritis.",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/ACarotenoids/AC-1.png",
    "images/Portfolio/OrgavitazForDeficiencies/ACarotenoids/AC-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/ACarotenoids/AC-3.png",
    "images/Portfolio/OrgavitazForDeficiencies/ACarotenoids/AC-4.png",
    "images/Portfolio/OrgavitazForDeficiencies/ACarotenoids/AC-5.png",



  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default ACarotenoids ;
